/**
 * Author: Claude Code
 * Generation: ICP filing footer for official website
 * Version: v3.2.281
 * Modified: 2026-01-20T00:00:00+08:00 // Add MIIT ICP link fixed at bottom
 */
import React from 'react';

const FooterICP: React.FC = () => {
  // Minimal inline style to ensure fixed bottom presence across all pages
  const style: React.CSSProperties = {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '28px',
    fontSize: '12px',
    color: 'rgba(255,255,255,0.85)',
    background: 'rgba(0,0,0,0.35)',
    backdropFilter: 'blur(4px)',
    zIndex: 1000,
    lineHeight: '1',
  };

  const linkStyle: React.CSSProperties = { color: 'inherit', textDecoration: 'none' };

  return (
    <footer role="contentinfo" style={style}>
      <a
        href="https://beian.miit.gov.cn"
        target="_blank"
        rel="noopener noreferrer"
        style={linkStyle}
      >
        浙ICP备2025191357号-2
      </a>
    </footer>
  );
};

export default FooterICP;
